/** @jsx jsx */
import React from 'react';
import ConfirmModal from 'components/organismos/ConfirmModal';
import FormContents from 'components/atoms/Form/FormContents';
import ListVerticalSeparator from 'components/molecules/ListVerticalSeparator';
import PrimaryButton from 'components/atoms/Button';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import useOrgTreesOptions from 'hooks/useOrgTreesOptions';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useHolidayAddForm } from './hooks';
import { jsx, css } from '@emotion/core';
import FormPadding from 'components/atoms/Form/FormPadding';
import Table from 'components/molecules/Table';
import Checkbox from 'components/molecules/Checkbox';
import LableTitle from 'components/atoms/LableTitle';
import FormHeader from 'components/templates/FormHeader';
import BlockUI from 'components/molecules/BlockUi';

const HolidayImportForm: React.FC = () => {
  const targetYear = sessionStorage.getItem('selectedYearHolidayMaster') || moment().format('YYYY');
  const selectedStartDate = `${targetYear}-01-01`;
  const selectedEndDate = `${targetYear}-12-31`;
  const orgTreesOptions = useOrgTreesOptions(selectedStartDate, selectedEndDate);
  const {formik, 
         holidayList, 
         confirmModalOpen, 
         closeConfirmModal, 
         selectedIndex, 
         setSelectedIndex, 
         selectedOrgCodes, 
         setSelectedOrgCodes,
         isLoading} = useHolidayAddForm();

  // history
  const history = useHistory();

  /**
   *  handle back
   */
  const handleBack = async () => {
    history.goBack();
  };

  return (
      <BlockUI blocking={isLoading}>
        <FormHeader title="祝日取り込み" />
        <FormContents customStyle={css({marginTop:'60px'})}>
          <FormPadding>
            <LableTitle customStyle={css({paddingLeft: '0px'})} title="表示されている祝日を登録します。" />
          </FormPadding>

        {/* <FormField>
          <RadioSelectForm
            label="組織選択"
            name="isAll"
            items={[
              {
                label: '全ての組織に設定',
                value: 'all',
              },
              {
                label: '組織を選択して設定',
                value: 'selection',
              },
            ]}
            value={String(formik.values.isAll ? 'all' : 'selection')}
            setValue={(e) => formik.setFieldValue('isAll', e.target.value === 'all')}
            readOnly={true}
          />
        </FormField>
        <div style={String(formik.values.isAll) === 'false' ? {} : { display: 'none' }}>
          <VerticalLabelMutilSelectForm
            label=""
            name="orgCodes"
            values={formik.values.orgCodes.map(
              (orgCode: string) => orgTreesOptions.find((item) => orgCode === item.value),
            )}
            setValue={(val: any) => {
              formik.setFieldValue('orgCodes', val.slice(0, -1).split(','));
            }}
            options={orgTreesOptions}
            isMulti={true}
          />
        </div> */}
        {/* <RadioSelectForm
          label=""
          name="option"
          items={[
            {
              label: '全ての組織',
              value: 'all',
            },
            {
              label: '組織を選択して設定',
              value: 'selection',
            },
          ]}
          value={String(formik.values.option)}
          setValue={formik.handleChange}
        /> */}
        {/* { formik.values.option === 'selection' ? (
          <div style={{ width: '200px' }}>
            <VerticalLabelSelectForm
              label=""
              name="organization"
              value=""
              setValue={(val: string) => formik.setFieldValue('organization', val)}
              options={orgTreesOptions}
              isMulti={true}
            />
          </div>
        ) : ''}
        */}

        <div>
          <ListVerticalSeparator
            title="取り込み祝日リスト"
            items={holidayList}
          />
        </div>
        <FormPadding customStyle={{ marginTop: '0px' }}>
          <LableTitle customStyle={css({paddingLeft: '0px'})} title="表示されている祝日を割り当てる組織をチェックしてください。" />
        </FormPadding>
        <div
          className='table-padding'
          css={css`
            overflow-x: hidden;
            max-width: 100%;
            table th {
              text-align: center;
            }
            table th:nth-of-type(1), 
            table td:nth-of-type(1) {
              width: 40px;
              text-align: center;
            }
            table th:nth-of-type(2), 
            table td:nth-of-type(2) {
              width: 500px;
            }
            table th:nth-of-type(3), 
            table td:nth-of-type(3) {
              width: 600px;
            }
            tbody {
              display: inline-block;
              overflow: hidden;
              border: 1px solid lightgray;
            }
            thead tr, tbody tr {
              display: table;
              width: 100%;
            }
          `}
        >
          <Table>
            <thead>
              <tr>
                <Table.HeaderCell>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  組織コード
                </Table.HeaderCell>
                <Table.HeaderCell>
                  組織名
                </Table.HeaderCell>
              </tr>
            </thead>
            <tbody>
              <tr key='all'>
                <Table.Cell customStyle={css({ width: '8px' })}>
                  <Checkbox
                    id="checkbox_stamp_all"
                    name="checkbox_stamp_all"
                    value='all'
                    checked={orgTreesOptions.length === selectedIndex.length && orgTreesOptions.length !== 0}
                    isCheckBoxTable={true}
                    onChange={(e) => {
                      if (orgTreesOptions.length === selectedIndex.length) {
                        setSelectedIndex([]);
                        formik.setFieldValue('isAll', false);
                      } else {
                        const allIndex = Object.keys(orgTreesOptions).map(Number);
                        setSelectedIndex(allIndex);
                        formik.setFieldValue('isAll', e.target.value === 'all');
                      }
                    }}
                  />
                </Table.Cell>
                <Table.Cell colSpan={2} customStyle={css({ textAlign: 'center' })}>全ての組織</Table.Cell>
              </tr>
              {orgTreesOptions && orgTreesOptions.length > 0 && (
                orgTreesOptions.map((org, index) => (
                  <tr key={index.toString()}>
                    <Table.Cell customStyle={css({ width: '8px' })}>
                      <Checkbox
                        id={org.value}
                        name={org.value}
                        value={org.value}
                        checked={selectedIndex.includes(index)}
                        isCheckBoxTable={true}
                        onChange={(e) => {
                          if (selectedIndex.includes(index)) {
                            setSelectedIndex(
                              selectedIndex.filter(
                                (selected) => selected !== index
                              )
                            );
                            setSelectedOrgCodes(
                              selectedOrgCodes.filter(
                                (selected) => selected !== e.target.value
                              )
                            );
                          } else {
                            setSelectedIndex([...selectedIndex, index]);
                            setSelectedOrgCodes([...selectedOrgCodes, e.target.value]);
                          }
                        }}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {org.value}
                    </Table.Cell>
                    <Table.Cell>
                      {org.label}
                    </Table.Cell>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        <FormSubmitArea customStyle={css({ textAlign: 'center', marginTop: '30px' })}>
          <div>
            {holidayList && holidayList.length
            ? (
              <PrimaryButton
                text="更新"
                onClick={formik.handleSubmit}
                minWidth="122px"
              />
            )
            : (
                <PrimaryButton
                  text="登録"
                  minWidth="122px"
                  disabled={true}
                />
            )}
            {/* <SecondaryButton
              text={'削除'}
              onClick={() => {}}
              minWidth="120px"
              customStyle={css({ marginLeft: '10px' })}
            /> */}
          </div>
          <PrimaryButton
            text="キャンセル"
            onClick={() => handleBack()}
            ghost={true}
          />
        </FormSubmitArea>
      </FormContents>
      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.handleSubmit}
        title="祝日マスタを登録"
        content="祝日マスタを登録します。よろしいですか？"
        submitText="登録する"
      />
    </BlockUI>
  );
};

export default HolidayImportForm;
